import { render } from "./RoleForm.vue?vue&type=template&id=245024d6&scoped=true"
import script from "./RoleForm.vue?vue&type=script&lang=js"
export * from "./RoleForm.vue?vue&type=script&lang=js"

import "./RoleForm.vue?vue&type=style&index=0&id=245024d6&scoped=true&lang=css"
import "./RoleForm.vue?vue&type=style&index=1&id=245024d6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245024d6"]])

export default __exports__